import React from 'react';
import {Box, TextField, Typography} from '@material-ui/core';
import {IHarvestSummaryFormProps} from './AddNewDataPointForm.types';

export const HarvestSummaryForm: React.FC<IHarvestSummaryFormProps> = ({
  data,
  onDataChange,
}) => {
  const handleChange = (field: string, value: any) => {
    onDataChange({...data, [field]: value});
  };

  return (
    <>
      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Total Harvested Quantity (kg)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Enter quantity"
          value={data.totalHarvestedQuantityKg}
          onChange={(e) =>
            handleChange('totalHarvestedQuantityKg', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Average Yield per Hectare (kg/ha)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Enter yield"
          value={data.avgYieldPerHectareKgha}
          onChange={(e) =>
            handleChange('avgYieldPerHectareKgha', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Harvest Method
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="e.g. Manual, Mechanical"
          value={data.harvestMethod}
          onChange={(e) => handleChange('harvestMethod', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          % First Grade Produce
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Enter percentage"
          value={data.pctFirstGradeProduce}
          onChange={(e) => handleChange('pctFirstGradeProduce', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Common Quality Issues
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="Describe any quality issues"
          value={data.commonQualityIssues}
          onChange={(e) => handleChange('commonQualityIssues', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Harvest Efficiency Scale (1-5)
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="e.g. 1 (Low) to 5 (High)"
          value={data.harvestEfficiencyScale}
          onChange={(e) =>
            handleChange('harvestEfficiencyScale', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Laborers Used
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          type="number"
          placeholder="Number of laborers"
          value={data.laborersUsed}
          onChange={(e) => handleChange('laborersUsed', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Equipment Used
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          placeholder="List equipment"
          value={data.equipmentUsed}
          onChange={(e) => handleChange('equipmentUsed', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Initial Processing Steps
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="Describe any initial processing steps"
          value={data.initialProcessingSteps}
          onChange={(e) =>
            handleChange('initialProcessingSteps', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Storage Conditions
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="Describe storage conditions (required)"
          value={data.storageConditions}
          onChange={(e) => handleChange('storageConditions', e.target.value)}
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>

      <Box mb={2}>
        <Typography style={{fontSize: 14, fontWeight: 500, marginBottom: 6}}>
          Transportation Arrangements
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={2}
          variant="outlined"
          size="small"
          placeholder="Describe transportation arrangements"
          value={data.transportationArrangements}
          onChange={(e) =>
            handleChange('transportationArrangements', e.target.value)
          }
          InputProps={{style: {backgroundColor: '#fff', borderRadius: 8}}}
        />
      </Box>
    </>
  );
};
